import React from 'react';

import UserImage from '../user-image';

import { styles } from './styles';

export default function ImageStacker({
  imageList,
  maxImagesToDisplay = 4,
  overridenStyles = null,
  bgColor = '',
}) {
  const classes = styles();
  const imageListCount = imageList.length;
  const additionalImagesCount = imageListCount - maxImagesToDisplay;
  return (
    <>
      <span className={classes.imagesStack}>
        {imageList.slice(0, maxImagesToDisplay).map((image) => (
          <span className={overridenStyles || classes.userImage} key={image.id}>
            <UserImage
              email={image?.email || ''}
              firstName={image.firstName || ''}
              lastName={image.lastName || ''}
              url={image.url}
              bgColor={bgColor}
            />
          </span>
        ))}
        {additionalImagesCount > 0 && (
          <span className={overridenStyles || classes.userImage}>
            <UserImage displayCount={additionalImagesCount} bgColor={bgColor} />
          </span>
        )}
      </span>
    </>
  );
}
